<template>
  <div class="search-input" v-if="showDialog">
    <el-dialog
      class="b-dialog"
      :show-close="false"
      width="400px"
      :visible.sync="showDialog">
      <header class="search-input_dialog-header" slot="title">
        <span class="search-input-label">保存查询</span>
        <i @click="showDialog = false" class="iconfont iconguanbi"></i>
      </header>
      <div class="search-input_dialog-content">
        <div class="search-input_dialog-content">
          <el-form label-position="top" label-width="80px">
            <el-form-item style="margin-bottom: 10px;" label="新建名称">
              <el-input v-model="queryName"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <p style="margin-bottom: 10px;">替换现有查询</p>
        <div class="q-list">
          <ul id="queryTree" class="ztree"></ul>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          :loading="loadingData"
          size="small"
          @click="deleteQuery">
          删 除
        </el-button>
        <el-button
          size="small"
          type="primary"
          @click="save">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import store from '../../../../store'
  import { selectMykDataSearch, addMykDataSearch, deleteMykDataSearch} from "../../../../api";

  let treeObj = null
  export default {
    name: "index",
    data () {
      return {
        loadingData: false,
        showDialog: false,
        queryName: '',
        queryParams: {},
        list: [],
        currentParamsObj: {},
        currentLevel: -1
      }
    },
    methods: {
      show (data) {
        treeObj && treeObj.destroy()
        treeObj = null
        selectMykDataSearch({
          token: store.state.user.userId,
          type: data.type,
          pageNum: 1,
          pageSize: 1000
        }).then(res => {
          this.list = res.data
          this.$nextTick(() => {
            this.initTree()
          })
        })
        this.queryParams = data
        this.showDialog = true
      },
      initTree () {
        let that = this
        function zTreeOnClick (event, treeId, treeNode) {
          that.currentLevel = treeNode.level
          const {id, name, searchJson, itype, userId, sessionId, createDate, createDateMin, createDateMax, delFlag, parentId, newRecord} = treeNode
          that.currentParamsObj = {
            id, name, searchJson, itype, userId, sessionId, createDate, createDateMax, createDateMin, delFlag, parentId, newRecord
          }
        }
        let setting = {
          simpleData: {
            enable: true,
            idKey: 'id'
          },
          data: {
            key: {
              name: 'name',
              children: "childList",
              isParent: 'parent'
            }
          },
          callback: {
            onClick: zTreeOnClick,
          }
        }
        let el = $('#queryTree')
        treeObj = $.fn.zTree.init(el, setting, this.list);
        treeObj.expandAll(true)
      },
      save () {
        if (!this.currentParamsObj.id && !this.queryName) {
          this.$message.warning('请输入名称')
          return
        }
        this.showDialog = false
        let params = {
          name: this.queryName,
          itype: this.queryParams.type,
          searchJson: this.queryParams.data,
          userId: store.state.user.userId,
        }

        if (this.currentParamsObj.id) {
          params.id = this.currentParamsObj.id
          params.name = this.currentParamsObj.name
        }

        addMykDataSearch(params).then(res => {
          this.loadingData = false
          this.showDialog = false
          this.$message.success('保存成功')
        })
      },
      checked (obj, index) {
        this.current = {
          index: index,
          currentParamsObj: obj
        }
      },
      deleteQuery () {
        if (!this.currentParamsObj.id || this.currentLevel <= 0) {
          this.$message.warning('请选择一个查询')
          return
        }
        this.loadingData = true
        deleteMykDataSearch({id: this.currentParamsObj.id}).then(res => {
          this.loadingData = false
          this.$message.success('删除成功')
          this.showDialog = false
        })
      }
    }
  }
</script>

<style lang="scss">
  .b-dialog{
    .el-form--label-top .el-form-item__label{
      padding: 0;
    }
    .el-dialog__body{
      padding: 0 20px !important;
    }
  }
</style>
<style lang="scss" scoped>
  .q-list{
    height: 200px;
    overflow: auto;
    border: 1px solid #e1e1e1;
    li{
      padding: 0 20px;
      line-height: 40px;
      color: #333333;
      font-size: 20px;
      cursor: pointer;
      &.active{
        color: #fff;
        background-color: #2B8DDE;
      }
    }
  }
</style>
